import { Box, Typography, useMediaQuery } from '@mui/material';
import { LLButton } from '@/components-library';

type TutorialProps = { onContinue: (e) => any };

const Tutorial = (props: TutorialProps) => {
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));
  const sx = {
    box: {
      width: '100%',
      margin: 'auto',
      textAlign: 'center',
      backgroundColor: 'rgb(255, 255, 255)',
      color: 'rgba(0, 0, 0, 0.87)',
      px: 3,
      pt: 0,
      pb: 3,
    },
    boxMobile: {
      width: 'unset',
    },
    form: {
      flex: 1,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      maxWidth: '952px',
      width: '90%',
      margin: 'auto',
      p: 0,
      '& .MuiCardContent-root': {
        px: 0,
      },
    },
    toolbarBtn: {
      minWidth: '130px',
    },
  };

  return (
    <>
      <Box sx={sx.form}>
        <Typography
          sx={{ textAlign: 'center', my: 2, color: 'primary.main' }}
          variant="h3"
        >
          Club Portal Tutorial
        </Typography>
        <Box sx={[sx.box, isMobile && sx.boxMobile]}>
          <iframe
            src="https://www.youtube.com/embed/hefy4lAM3ok"
            // title={faqItem.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{
              borderRadius: '8px',
              width: '60%',
              aspectRatio: '16 / 9',
            }}
            loading="lazy"
          ></iframe>
          <Box
            sx={{
              maxWidth: '952px',
              margin: 'auto',
              mt: 2,
              pb: 4,
              gap: 2,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <LLButton onClick={props.onContinue} sx={sx.toolbarBtn}>
              CONTINUE
            </LLButton>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Tutorial;
